(function (root) {
  'use strict';

  function normalizeSize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(',', '.')
      .replace(/\b(eu|48h|express)\b/g, '')
      .replace(/[^0-9.]/g, '')
      .replace(/\.$/, '');
  }

  function chooseVariant(variants, sizes, minimum, maximum) {
    var requested = (sizes || []).map(normalizeSize).filter(Boolean);
    var candidates = (variants || []).filter(function (variant) {
      if (variant.available === false) return false;
      if (minimum !== null && variant.price < minimum) return false;
      if (maximum !== null && variant.price > maximum) return false;
      if (!requested.length) return true;
      return (variant.options || []).some(function (option) {
        return requested.indexOf(normalizeSize(option)) !== -1;
      });
    });
    candidates.sort(function (a, b) { return a.price - b.price; });
    return candidates[0] || null;
  }

  function readNumber(params, key) {
    var value = params.get(key);
    if (!value) return null;
    var number = Number(String(value).replace(',', '.'));
    return Number.isFinite(number) ? Math.round(number * 100) : null;
  }

  function formatWholeEuros(value) {
    var number = Number(value);
    if (!Number.isFinite(number)) number = 0;
    var locale = (document.documentElement.lang || 'fr-FR').replace('_', '-');
    return new Intl.NumberFormat(locale, {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0
    }).format(Math.round(number));
  }

  function parseWholeEuros(value) {
    var number = Number(String(value || '').replace(/[^0-9,.-]/g, '').replace(',', '.'));
    return Number.isFinite(number) ? Math.round(number) : 0;
  }

  function initPriceFields(scope) {
    (scope || document).querySelectorAll('.cpx-price-display:not([data-price-ready])').forEach(function (display) {
      var bound = document.getElementById(display.getAttribute('data-price-bound'));
      if (!bound) return;
      var sync = function () {
        display.value = formatWholeEuros(bound.value);
      };
      var commit = function () {
        var value = parseWholeEuros(display.value);
        var minimum = bound.min === '' ? null : Number(bound.min);
        var maximum = bound.max === '' ? null : Number(bound.max);
        if (minimum !== null && value < minimum) value = minimum;
        if (maximum !== null && value > maximum) value = maximum;
        bound.value = String(value);
        sync();
        bound.dispatchEvent(new Event('change', { bubbles: true }));
      };
      display.setAttribute('data-price-ready', 'true');
      display.addEventListener('change', function (event) {
        event.stopImmediatePropagation();
      }, true);
      display.addEventListener('focus', function () {
        display.value = String(parseWholeEuros(display.value));
        display.select();
      });
      display.addEventListener('blur', commit);
      display.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          display.blur();
        }
      });
      bound.addEventListener('change', sync);
      sync();
    });
  }

  function fixPriceSliderEvents(scope) {
    (scope || document).querySelectorAll('.cpx-filter-price .range-inner').forEach(function (slider) {
      if (!slider.noUiSlider || slider.getAttribute('data-cpx-price-events') === 'true') return;
      var bounds = slider.closest('.cpx-filter-price').querySelectorAll('.cpx-price-bound');
      if (bounds.length !== 2) return;
      slider.noUiSlider.off('change');
      slider.noUiSlider.on('change.cpxPrice', function (values, handle) {
        bounds[handle].dispatchEvent(new Event('change', { bubbles: true }));
      });
      slider.setAttribute('data-cpx-price-events', 'true');
    });
  }

  function apply() {
    var params = new URLSearchParams(root.location.search);
    var sizes = [];
    ['filter.v.option.taille', 'filter.v.option.size', 'filter.p.m.custom.tailles_disponibles'].forEach(function (key) {
      sizes = sizes.concat(params.getAll(key));
    });
    var minimum = readNumber(params, 'filter.v.price.gte');
    var maximum = readNumber(params, 'filter.v.price.lte');
    if (!sizes.length && minimum === null && maximum === null) return;

    document.querySelectorAll('.product-card[data-cp-available-variants]').forEach(function (card) {
      var variants;
      try { variants = JSON.parse(card.getAttribute('data-cp-available-variants') || '[]'); }
      catch (_error) { return; }
      var selected = chooseVariant(variants, sizes, minimum, maximum);
      if (!selected) {
        card.hidden = true;
        card.setAttribute('aria-hidden', 'true');
        return;
      }
      var price = card.querySelector('.price');
      if (!price) return;
      var locale = document.documentElement.lang || 'fr-FR';
      var currency = (root.Shopify && root.Shopify.currency && root.Shopify.currency.active) || 'EUR';
      price.textContent = new Intl.NumberFormat(locale, {
        style: 'currency', currency: currency,
        minimumFractionDigits: selected.price % 100 ? 2 : 0,
        maximumFractionDigits: selected.price % 100 ? 2 : 0
      }).format(selected.price / 100);
      price.setAttribute('data-cp-filtered-price', String(selected.price));
    });
  }

  var api = { normalizeSize: normalizeSize, chooseVariant: chooseVariant, apply: apply };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  root.CoproomFilterPrice = api;
  if (typeof document !== 'undefined') {
    var start = function () {
      initPriceFields(document);
      fixPriceSliderEvents(document);
      apply();
      new MutationObserver(function () {
        initPriceFields(document);
        fixPriceSliderEvents(document);
        setTimeout(function () { fixPriceSliderEvents(document); }, 250);
      }).observe(document.body, {
        childList: true,
        subtree: true
      });
      setTimeout(function () { fixPriceSliderEvents(document); }, 250);
      setTimeout(function () { fixPriceSliderEvents(document); }, 1000);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  }
})(typeof window !== 'undefined' ? window : globalThis);
